/** Chief HC flag on profile payload (`userInfo` in localStorage). */
export function readChiefHcFromStorage(): boolean {
  try {
    const raw = localStorage.getItem("userInfo");
    if (!raw) return false;
    const info = JSON.parse(raw) as { chief_hc?: string };
    return info?.chief_hc === "Y";
  } catch {
    return false;
  }
}

export function isChiefCoachFlag(value: unknown): boolean {
  return value === "Y" || value === true || value === "true";
}
